import { computed, inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { LoggerService } from './logger/logger.service';

export interface GuardLoadingState {
  activeGuards: Set<string>;
  count: number;
  isLoading: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class GuardLoadingService {
  private readonly logger = inject(LoggerService);
  private activeGuards = signal<Set<string>>(new Set());

  readonly loadingState = computed<GuardLoadingState>(() => {
    const guards = this.activeGuards();
    return {
      activeGuards: guards,
      count: guards.size,
      isLoading: guards.size > 0
    };
  });

  readonly loadingState$ = toObservable(this.loadingState);

  readonly isLoading = computed(() => this.loadingState().isLoading);
  readonly activeCount = computed(() => this.loadingState().count);

  startLoading(guardName: string): void {
    this.activeGuards.update(guards => {
      const newSet = new Set(guards);
      newSet.add(guardName);
      return newSet;
    });
  }

  stopLoading(guardName: string): void {
    this.activeGuards.update(guards => {
      const newSet = new Set(guards);
      newSet.delete(guardName);
      return newSet;
    });
  }

  reset(): void {
    this.activeGuards.set(new Set());
  }
}
